import React from 'react';
import PropTypes from 'prop-types';

const MoneySendSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 21}`}
      height={`${height || 20}`}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.48633 11.4583C8.48633 12.2667 9.11134 12.9167 9.87801 12.9167H11.4447C12.1113 12.9167 12.653 12.35 12.653 11.6417C12.653 10.8833 12.3197 10.6083 11.828 10.4333L9.31966 9.55834C8.82799 9.38334 8.49467 9.11668 8.49467 8.35001C8.49467 7.65001 9.03632 7.07501 9.70299 7.07501H11.2697C12.0363 7.07501 12.6613 7.72501 12.6613 8.53335"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path 
        d="M10.5698 6.25V13.75"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.903 10C18.903 14.6 15.1697 18.3334 10.5697 18.3334C5.96966 18.3334 2.23633 14.6 2.23633 10C2.23633 5.40002 5.96966 1.66669 10.5697 1.66669"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9032 5.00002V1.66669H15.5698"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7363 5.83335L18.903 1.66669"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

MoneySendSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default MoneySendSvg;
